import { render, staticRenderFns } from "./notfount.vue?vue&type=template&id=5a494466&scoped=true&"
import script from "./notfount.vue?vue&type=script&lang=js&"
export * from "./notfount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a494466",
  null
  
)

export default component.exports